import React from 'react';
import { makeSeverityDropdownOptions } from '../models/severity';
import { CustomDropdown } from '../custom-dropdown/CustomDropdown';

export const SeverityDropdown = ({
    selectSeverityLevel,
    selectedSeverityLevel,
    label
}) => (
    <CustomDropdown
        label={label || 'Severity'}
        options={makeSeverityDropdownOptions()}
        onChange={selectSeverityLevel}
        value={selectedSeverityLevel}
    />
);
